import { render, staticRenderFns } from "./CurriculumTree.vue?vue&type=template&id=3eb04b3c&scoped=true&"
import script from "./CurriculumTree.vue?vue&type=script&lang=js&"
export * from "./CurriculumTree.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumTree.vue?vue&type=style&index=0&id=3eb04b3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb04b3c",
  null
  
)

export default component.exports